import AnswerRichTextEditor from './AnswerRichTextEditor.component';

export default AnswerRichTextEditor;